var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActionForwardStuff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#94C843"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.333 14.333a7.573 7.573 0 0 1-2.38-.38.683.683 0 0 0-.68.16l-1.466 1.467a10.03 10.03 0 0 1-4.394-4.393L9.88 9.713a.64.64 0 0 0 .167-.666 7.573 7.573 0 0 1-.38-2.38C9.667 6.3 9.367 6 9 6H6.667C6.3 6 6 6.3 6 6.667 6 12.927 11.073 18 17.333 18c.367 0 .667-.3.667-.667V15c0-.367-.3-.667-.667-.667Zm-9.98-7h1c.047.587.147 1.167.3 1.72l-.8.807a10.232 10.232 0 0 1-.5-2.527Zm9.314 9.314a9.936 9.936 0 0 1-2.534-.507l.8-.8c.567.16 1.147.26 1.734.3v1.007ZM16 11.333 19.333 8 16 4.667v2h-2.667v2.666H16v2Z",
  fill: "#fff"
})));
export { SvgActionForwardStuff as ReactComponent };
export default __webpack_public_path__ + "images/action-forward-stuff.svg";